"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dedupeStringArray = exports.extractUrlsFromText = exports.getCompressedAppMenuPath = exports.getDomainFromHostname = exports.iconPath = exports.colorWheel = void 0;
const colorWheel = (i) => {
    const colors = [
        "#15A5F6",
        "#00fa19",
        "#fc0e0e",
        "#e0ff3a",
        "#9111b8",
        "#563b26",
        "#cd8440",
    ];
    const index = i % 7;
    return colors[index];
};
exports.colorWheel = colorWheel;
const iconPath = (file, user) => {
    return "/icons/" + ((user === null || user === void 0 ? void 0 : user.theme) || "light-mode") + "/" + file;
};
exports.iconPath = iconPath;
const getDomainFromHostname = (hostname) => {
    try {
        return hostname.split(".").reverse().splice(0, 2).reverse().join(".");
    }
    catch (err) {
        return hostname;
    }
};
exports.getDomainFromHostname = getDomainFromHostname;
const getCompressedAppMenuPath = (id, pathRoot, storeUser) => {
    let finalPath = "/icons/" + (storeUser === null || storeUser === void 0 ? void 0 : storeUser.theme) + "/app_logos/" + pathRoot + "-activity.svg";
    // finalPath += selectedMenuId === id ? "-bg.svg" : "-nobg.svg";
    return finalPath;
};
exports.getCompressedAppMenuPath = getCompressedAppMenuPath;
const extractUrlsFromText = (text) => {
    // console.log("[extractUrls] extracted urls from: ", text);
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.match(urlRegex);
};
exports.extractUrlsFromText = extractUrlsFromText;
const dedupeStringArray = (source) => {
    const arrayMap = new Map();
    source.forEach((item) => {
        if (!arrayMap.has(item)) {
            arrayMap.set(item, true);
        }
    });
    return Array.from(arrayMap.keys());
};
exports.dedupeStringArray = dedupeStringArray;
